import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ChangeDetectionStrategy
} from '@angular/core';
import { CurrentInfoService, CurrentUserService } from '@homeleite/domain';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map, Observable } from 'rxjs';
import { MAIN_MENU } from '../../features/features-catalog';
import { MenuItem } from './menu/menu.component';
import { LayoutBaseComponent, LayoutUser } from '../base/layout-base.component';
import { Router } from '@angular/router';
import { AuthService } from '@homeleite/arch';
import { ControllersApiRepository } from '../../../../../../libs/domain/src/lib/controllers/controllers-api.repository';

@UntilDestroy()
@Component({
    selector: 'admin-layout',
    templateUrl: './layout-admin.component.html',
    styleUrls: ['./layout-admin.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LayoutAdminComponent {
    @Input() fillPrimary = false;

    @Input() pageTitle: string = null;

    @Input() showSearch = false;

    @Input() searchPlaceholder = 'Pesquisar';

    @Input() showMenu = true;

    @Input() showBack = false;

    @Input() showActionBar = true;

    @Input() showLogout = false;

    @Output() backClick = new EventEmitter<MouseEvent>();

    @Output() searchChange = new EventEmitter<string>();

    @ViewChild(LayoutBaseComponent) layoutBase: LayoutBaseComponent;

    readonly mainMenu = MAIN_MENU;
    submenu: MenuItem | null = null;
    homePath = '/home';
    user$: Observable<LayoutUser>;
    onSideBackClickFn = () => this.onSideBackClick();

    constructor(
        private authService: AuthService,
        public currentUser: CurrentUserService,
        private currentInfoService: CurrentInfoService,
        public router: Router
    ) {
        this.user$ = this.currentUser.$user.pipe(
            untilDestroyed(this),
            map((user) => ({ name: user.fullName, identifier: user.email }))
        );
    }

    onSideBackClick() {
        if (this.submenu) {
            this.submenu = null;
        } else {
            this.layoutBase.closeMenu();
        }
    }

    onSubmenuClick(submenu: MenuItem) {
        this.submenu = submenu;
        this.layoutBase.resetMenu();
    }

    onBackClick(event: MouseEvent) {
        if (this.backClick.observed) {
            this.backClick.emit(event);
        } else {
            this.layoutBase.goBack();
        }
    }

    onLogout(): void {
        this.authService.publishLogout();
        this.currentInfoService.clear();
        setTimeout(() => location.reload(), 150);
    }
}
